
import React, { ReactEventHandler, SyntheticEvent, useEffect, useState } from 'react';
import { render } from 'react-dom';
import FormControl from '@mui/material/FormControl';
import { Button, Checkbox, FormControlLabel, FormHelperText, Input, InputLabel, Link, ListItemText, MenuItem, OutlinedInput, Select, TextField } from '@mui/material';
import ContractorService from "../../../services/contractor/contractor.service";
import { SnackbarKey, closeSnackbar, enqueueSnackbar } from 'notistack';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import ContractorCardValidators from "./validators"
import { pl } from 'date-fns/locale/pl';
import { relative } from 'path';
import { abort } from 'process';

import "./formdata.css"
import { LookupCollection, LookupData } from '../../../components/grid/GridUtils';
import authService from '../../../services/auth/auth.service';
import { CurrentSorter } from 'slickgrid-react';
import {ContractorData} from "./index"
import contractorService from '../../../services/contractor/contractor.service';

registerLocale('pl', pl)


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

interface CardFormParams{
    contractor_id:number
  }

  class InputState{
    helperText: string = ''
    error: boolean = false 
  } 

  


  export interface CardFormState{

    input_nip_state : InputState; 
    input_shortname_state : InputState;
    input_name_state : InputState;
    input_contactdate_state : InputState;

    input_phone_state : InputState;
    input_street_state : InputState;
    input_city_state : InputState;
    input_postcode_state : InputState;
    input_country_state : InputState;
    input_province_state : InputState;
    input_cor_street_state : InputState;
    input_cor_city_state : InputState;
    input_cor_postcode_state : InputState;
    input_cor_country_state : InputState;
    input_cor_province_state : InputState;
    input_mail_state : InputState;
    input_fax_state : InputState;
    input_regon_state : InputState;
    input_krs_state : InputState;
    input_webpage_state : InputState;

    c_data : ContractorData;

    alertErrorMsg : string[];
    alertInfo : string;
    alertError : string;
    alertWarning : string;
    lookupData  :LookupCollection[] ;

    data_contractorgroups: LookupData[];
    data_contractorstates : LookupData[];
    data_fairs : LookupData[];
    data_contractortrades : LookupData[];
    data_newmstate : LookupData[];
    data_iis : LookupData[];
    data_classifications : LookupData[];
    data_ctypes : LookupData[];
    data_gtu : LookupData[];
    
  }

  const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
    'Omar Alexander',
    'Carlos Abbott',
    'Miriam Wagner',
    'Bradley Wilkerson',
    'Virginia Andrews',
    'Kelly Snyder',
  ];

  const names2 = [
    'AAA',
    'BBB',
    'CCCC',
    'DDDD',
    
  ];
  
const CONTRACTOR_STORAGE_QUERY = authService.getCurrentUser()?.shrt + '_crm-' + 'contractors' + '-query' 

const LOCAL_STORAGE_CONTRACTOR_EDIT_LIST = authService.getCurrentUser()?.shrt + '_crm-contractor-edit-list' 
const LOCAL_STORAGE_CONTRACTOR_EDIT_INDEX = authService.getCurrentUser()?.shrt + '_crm-contractor-edit-index' 
  
export class ContractorCardFormData extends React.Component<CardFormParams, CardFormState> {
    contractor_id :number
    date: Date;
    own_contractor_groups : string[];
    Validators: ContractorCardValidators;
    item_list:any[];
    item_index:number;
   
   
    
  checkItemIsEditable(dataContext: any) {
    var isEditable = false
    if (dataContext) {
      isEditable = authService.isAdmin() 
      if (!authService.isAdmin()){
        if ((dataContext?.archival == null) || (dataContext?.archival <=0)){
          if (this.own_contractor_groups &&  Array.isArray(this.own_contractor_groups) &&  this.own_contractor_groups.length>0){
              for (const group in dataContext?.group_names_array){
                if (this.own_contractor_groups.includes(dataContext?.group_names_array[group])){ 
                  isEditable = true;
                  break;
                }  
              }
          }else{
            isEditable = false;
          }
        }else{
          isEditable = false;
        }
      }else{
        isEditable = true;
      } 
    }
    return isEditable;
  }


    componentDidMount() {
     
      this.getcontractorlookups();
    }

    getContractorDataByID(contractorId: number, query:string) {
      return ContractorService.getContractorDataByID(contractorId, query)
    }

    getcontractorlookups(){
      return ContractorService.getcontractorlookups().then(response => {
           let tmp1 : LookupCollection[] = [];
            if ((response) && (Array.isArray(response.data))){
                tmp1  = response.data
            }

            let data_contractorgroups: LookupData[] = [];
            let data_contractorstates : LookupData[] = [];
            let data_fairs : LookupData[] = [];
            let data_contractortrades : LookupData[] = [];
            let data_newmstate : LookupData[] = [];
            let data_iis : LookupData[] = [];
            let data_classifications : LookupData[] = [];
            let data_ctypes : LookupData[] = [];
            let data_gtu : LookupData[] = [];
            
            tmp1?.forEach((item:LookupCollection) => {
              if (item.name === 'contractorgroups'){
                data_contractorgroups = item.data; 
              } 
              else if (item.name === 'contractorstates'){
                data_contractorstates = item.data; 
              } 
              else if (item.name === 'fairs'){
                data_fairs = item.data; 
              }
              else if (item.name === 'contractortrades'){
                data_contractortrades = item.data; 
              }  
              else if (item.name === 'newmstates'){
                data_newmstate = item.data; 
              }  
              else if (item.name === 'iis'){
                data_iis = item.data; 
              }  
              else if (item.name === 'classifications'){
                data_classifications = item.data; 
              }  
              else if (item.name === 'contractortypes'){
                data_ctypes = item.data; 
              }  
              else if (item.name === 'gtu'){
                data_gtu = item.data; 
              }  
              
            });
        
           
            this.setState((state: CardFormState) => ({
              ...state,
              lookupData : tmp1,
              data_contractorgroups : data_contractorgroups,
              data_contractorstates : data_contractorstates,
              data_fairs : data_fairs,
              data_contractortrades : data_contractortrades,
              data_newmstate : data_newmstate,
              data_iis : data_iis,
              data_classifications : data_classifications,
              data_ctypes : data_ctypes,
              data_gtu : data_gtu
            }),  () => {
              ContractorService.getOwnContractorGroups().then((response: string[]) => { 
                if ((response) && (Array.isArray(response))){
                  this.own_contractor_groups = response  
                  
                    var query = localStorage[CONTRACTOR_STORAGE_QUERY] || '';
          
                    this.getContractorDataByID(this.contractor_id, query).then((response: any) => {
                        console.log('Get data OK')
                        var data : ContractorData = response
                  
                        if (this.checkItemIsEditable(response)){
                            this.setState((state: CardFormState) => ({
                              ...state,
                              c_data : data,
                              alertError: ""
                            }))
                       
                      
                        }else{
                          this.setState((state: CardFormState) => ({
                            ...state,
                            c_data : new ContractorData(),
                            alertError: "Nie masz uprawnień do edycji tego kontrahenta!"
                          }));
                        }
      
                    }
      
                    ). catch(
                      () => {
                        let tmp : LookupCollection[]=[];
                        this.setState((state: CardFormState) => ({
                              ...this.state,
                              lookupData : tmp,
                              alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
                        }));
                        
                        return tmp;
                      }
                    )
                }else{
                  this.own_contractor_groups = []
                }   
              }
              ).catch(
                () => {
                  let tmp : LookupCollection[] = [];
                  this.setState((state: CardFormState) => ({
                        ...state,
                        alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
                  }));
                  this.own_contractor_groups=[]
                  return tmp;
                }
              )
          })

        }).catch(
          () => {
            let tmp : LookupData[] = [];
            this.setState((state: CardFormState) => ({
                  ...state,
                  alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
            }));
            this.own_contractor_groups=[]
            return tmp;
          }
        )
    }
        
            
            
            
    constructor(public readonly props: CardFormParams) {
        super(props);
        this.Validators = new ContractorCardValidators(this)
        this.contractor_id = props.contractor_id
        this.own_contractor_groups =[]
        this.date = new Date()


        let item_list = localStorage.getItem(LOCAL_STORAGE_CONTRACTOR_EDIT_LIST)
        let lastIdx = localStorage.getItem(LOCAL_STORAGE_CONTRACTOR_EDIT_INDEX)

        if (lastIdx && item_list){
          this.item_list = JSON.parse(item_list as string)
            this.item_index = this.item_list.findIndex((element) => element.id==this.contractor_id)
            localStorage.setItem(LOCAL_STORAGE_CONTRACTOR_EDIT_INDEX, JSON.stringify(this.item_index))
          
          //console.log(this.item_index)
        }else{
          this.item_list = []
          this.item_index =0
        }
        //let last =  lastIdx >= item_List.count() 

        this.state={
          input_nip_state: {helperText: '', error:false},
          input_shortname_state: {helperText: '', error:false},
          input_name_state: {helperText: '', error:false},
          input_contactdate_state: {helperText: '', error:false},

          input_phone_state: {helperText: '', error:false},
          input_street_state: {helperText: '', error:false},
          input_city_state: {helperText: '', error:false},
          input_postcode_state: {helperText: '', error:false},
          input_country_state: {helperText: '', error:false},
          input_province_state: {helperText: '', error:false},
          input_cor_street_state: {helperText: '', error:false},
          input_cor_city_state: {helperText: '', error:false},
          input_cor_postcode_state: {helperText: '', error:false},
          input_cor_country_state: {helperText: '', error:false},
          input_cor_province_state: {helperText: '', error:false},
          input_mail_state: {helperText: '', error:false},
          input_fax_state: {helperText: '', error:false},
          input_regon_state: {helperText: '', error:false},
          input_krs_state: {helperText: '', error:false},
          input_webpage_state: {helperText: '', error:false},

          

          c_data:new ContractorData(),
          
          alertInfo:"",
          alertError:"",
          alertWarning:"", 
          alertErrorMsg:[],
          lookupData : [],

          data_contractorgroups:[],
          data_contractorstates : [],
          data_fairs : [],
          data_contractortrades : [],
          data_newmstate :[],
          data_iis : [],
          data_classifications :  [],
          data_ctypes : [],
          data_gtu :  []

        }
    }

   

    onMaxlength100Validator(event: { target: any}) {

    }


    action(snackbarId: SnackbarKey){
      return(
      <>
         <Button  onClick={() => { closeSnackbar(snackbarId) }} variant="contained">Zamknij</Button>
        
      </>
      )
    }
    

    


    render() :React.ReactNode{
      if (this.state.alertErrorMsg.length > 0){
        for (const msg in this.state.alertErrorMsg){
          enqueueSnackbar(this.state.alertErrorMsg[msg], {action: this.action, variant: 'warning', preventDuplicate: true,  autoHideDuration:5000, persist: true})
        }
        this.setState((state: CardFormState) => ({
          ...state,
          alertErrorMsg: []
        }));
      }

      if (this.state.alertInfo) {
        enqueueSnackbar(this.state.alertInfo, {variant: 'info', preventDuplicate: true, autoHideDuration:5000, persist: false}) 
        this.setState((state: CardFormState) => ({
          ...state,
          alertInfo: ''
        }));
      }

      if (this.state.alertWarning) {
        enqueueSnackbar(this.state.alertWarning, {variant: 'warning', preventDuplicate: true, autoHideDuration:5000, persist: false})
        this.setState((state: CardFormState) => ({
          ...state,
          alertWarning: ''
        }));
      }
      if (this.state.alertError) {
        enqueueSnackbar(this.state.alertError, {variant: 'error', preventDuplicate: true, autoHideDuration:5000, persist: false})
        this.setState((state: CardFormState) => ({
          ...state,
          alertError: ''
        }));
      }


      
   
        return <>
            <section className="content">
              <div className="container-fluid">
              <div className="cardMenu">
                        <div className='cardLeftSubMenu'> 
                        { <button className="btn btn-card btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                               onClick={() => {
                                window.location.href = '/contractors'
                              }}
                               >
                               Powrót do listy
                               </button>   
                            }
                        </div>
                        
                        
                        <div className='cardCenterSubMenu'>
                        { <button className="btn btn-card btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                               disabled = {this.item_index ==0}
                               onClick={() => {
                                var query = localStorage[CONTRACTOR_STORAGE_QUERY] || '';

                                if (Array.isArray(this.item_list)){
                                  if (this.item_index <this.item_list.length+1){
                                    localStorage.setItem(LOCAL_STORAGE_CONTRACTOR_EDIT_INDEX, JSON.stringify(this.item_index-1))
                                    window.location.href = "/contractors/card/" + this.item_list[this.item_index-1].id
                                  }
                                 
                                }

                                //console.log('AA')
                                //console.log(query)
                                //contractorService.getPrevContractorDataByID(this.contractor_id, query).then(
        
                                //  (response) =>  {
                                //    window.location.href = "/contractors/card/" + response.id
                               //</div>  }
                              // ).catch(
                               //   (error) => {
                               //    try{
                                     
                               //      this.setState((state: CardFormState,) => ({
                               //        ...state,
                               //        alertError: "Błąd podczas pobierania danych poprzedniego kontrahenta"
                               //      }));
                               //    }catch{
                         
                        //           }
                          //</div>       }
                            //   )
                              }}
                               >
                               Poprzedni
                               </button>   
                            }
                            { <button className="btn btn-card btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                               disabled = {this.item_index >=this.item_list.length-1}
                               onClick={() => {
                                var query = localStorage[CONTRACTOR_STORAGE_QUERY] || '';
                                //console.log('AA')
                                //console.log(query)
                                //contractorService.getNextContractorDataByID(this.contractor_id, query).then(
        
                                //  (response) =>  {
                                    //window.location.href = "/contractors/card/" + response.id
                                    if (Array.isArray(this.item_list)){
                                      if (this.item_index <this.item_list.length+1){
                                        localStorage.setItem(LOCAL_STORAGE_CONTRACTOR_EDIT_INDEX,JSON.stringify(this.item_index+1))
                                      
                                        window.location.href = "/contractors/card/" + this.item_list[this.item_index+1].id
                                      }
                                    }
                                //</div> }
                               //).catch(
                                //  (error) => {
                                 //  try{
                                     
                                  //   this.setState((state: CardFormState,) => ({
                                  //     ...state,
                                  //     alertError: "Błąd podczas pobierania danych następmnego kontrahenta"
                                  //   }));
                                  // }catch{
                         
                                  // }
                                // }
                               //)
                              }}
                               >
                               Następny
                               </button>   
                            }
  
                        </div><div className='cardRightSubMenu'>
                            
                            
                           { <button className="btn btn-card btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                               onClick={() => {
                                contractorService.editcontractor(this.state.c_data).then(
        
                                  () =>  {
                                    this.setState((state: CardFormState,) => ({
                                      ...state,
                                      alertInfo:  "Poprawnie zapisano dane"
                                    }));
                                   
                                 }
                               ).catch(
                                  (error) => {
                                   try{
                                     
                                     this.setState((state: CardFormState,) => ({
                                       ...state,
                                       alertError: "Błąd podczas zapisu danych"
                                     }));
                                   }catch{
                         
                                   }
                                 }
                               )
                              }}
                               >
                               Zapisz
                               </button>   
                            }
                            { <button className="btn btn-card btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                               onClick={() => {
                                window.location.reload()
                              }}
                               >
                                Anuluj
                               </button>   
                            }
                            
                        </div>
                    </div>
                <div className="row">
                  {/* left column */}
                  <div className="col-md-6">
                    <div className="card card-primary" style={{padding:"5px"}}>
                      <div className="card-header" style={{marginBottom:10}}>
                        <h3 className="card-title">Dane podstawowe</h3>
                        
                      </div>
                      
                        <div style={{textAlign:"center"}}>
                          <TextField
                            label="NIP"
                            id="input-nip"
                            placeholder='Wprowadź NIP kontrahenta'
                            size="small"
                            value={this.state.c_data.nip == null || this.state.c_data.nip == undefined ? '' : this.state.c_data.nip}
                            InputLabelProps={{ shrink: true }}
                            required={true}
                            error={this.state.input_nip_state.error}
                            helperText={this.state.input_nip_state.helperText}
                            onChange={this.Validators.onNIPchange.bind(this.Validators)}
                            style={{marginBottom:20, width:"32%", float:"left", marginRight:"5px"}}
                          />
                          <TextField
                            label="Nazwa skrócona"
                            id="input-shortname"
                            placeholder='Wprowadź nazwę skróconą kontrahenta'
                            size="small"
                            InputLabelProps={{ shrink: true }}
                            required={true}
                            value={this.state.c_data.shortname}
                            error={this.state.input_shortname_state.error}
                            helperText={this.state.input_shortname_state.helperText}
                            onChange={this.Validators.onShortnamechange.bind(this.Validators)}
                            style={{marginBottom:20, width:"65%", float:"left"}}

                          />
                          <div style={{clear:"both"}}></div>
                        </div>  
                       
                        <div>  
                            <TextField
                              label="Nazwa"
                              id="input-name"
                              placeholder='Wprowadź pełną nazwę kontrahenta'
                              size="small"
                              InputLabelProps={{ shrink: true }}
                              required={true}
                              value={this.state.c_data.name == null || this.state.c_data.name == undefined ? '' : this.state.c_data.name}
                              error={this.state.input_name_state.error}
                              helperText={this.state.input_name_state.helperText}
                              onChange={this.Validators.onNamechange.bind(this.Validators)}
                              style={{marginBottom:20, width:"62%", float:"left", marginRight:"5px"}}
                            />
                            <div style={{marginBottom:20, zIndex:2, position:"relative", float:"left", width:"35%"}}>
                              <label style={{paddingLeft:5, paddingRight:5, position:"absolute", backgroundColor:"white", transform: "translate(14px, -10px) scale(0.75)", zIndex:1, top:0, fontWeight:700, color:"rgba(0, 0, 0, 0.6)", fontSize:"1rem", fontFamily:"'Roboto','Helvetica','Arial',sans-serif"}} className="" data-shrink="true" htmlFor="input-contactdate" id="input-contactdate-label">Data nast. kontaktu</label>
                              <DatePicker
                                //selected={this.state.contactdate}
                                showTimeSelect
                                selected={(this.state.c_data.contactdate == 0 || this.state.c_data.contactdate == null) ? null : new Date(this.state.c_data.contactdate)}
                                //onSelect={handleDateSelect} //when day is clicked
                                onChange={this.Validators.onContactdatechange.bind(this.Validators)} //only when value has changed
                                locale="pl"
                                dateFormat={"yyyy-MM-dd HH:mm"}
                                showIcon
                                //disabledKeyboardNavigation
                                onChangeRaw={(e)=> {
                                 
                                  // let s=document.getElementById("input-contactdate") as HTMLInputElement
                                 // s.value =moment(this.state.contactdate).format("yyyy-MM-DD HH:mm");
                                }}
                               
                                id={"input-contactdate"}
                                todayButton="Dzisiaj"
                                autoComplete='off'
                                isClearable={true}
                                placeholderText="Wprowadź datę"
                                //minDate={new Date()}
                                //withPortal
                              />
                        
                            </div>
                            <div style={{clear:"both"}}></div>
                          
                            <div style={{position:"relative", float:"left", width:"33%", marginRight:"5px"}}>
                                  
                            <label style={{paddingLeft:5, paddingRight:5, position:"absolute", backgroundColor:"white", transform: "translate(14px, -10px) scale(0.75)", zIndex:1, top:0, fontWeight:700, color:"rgba(0, 0, 0, 0.6)", fontSize:"1rem", fontFamily:"'Roboto','Helvetica','Arial',sans-serif"}} className="" data-shrink="true" htmlFor="input-labels_array" id="input-labels_array-label">Etykiety</label>
                              
                              <Select
                                multiple
                                onChange={this.Validators.handleLabelsChange.bind(this.Validators)}
                                id="input-labels_array"
                                size="small"
                                value={this.state.c_data.labels_array}
                                error={this.state.input_name_state.error}
                                //renderValue={(selected) => selected.join(', ')}
                                renderValue={(selected) => selected
                                  .filter((val) => val != "None")
                                  .map((val) => val)
                                  .join(", ")}
                                style={{marginBottom:5, width:"100%", float:"left", marginRight:"5px"}}
                                >
                                {
                                this.state.data_fairs.map((data) => (
                                  <MenuItem key={data.label} value={data.label}>
                                     <Checkbox checked={this.state.c_data.labels_array.indexOf(data.label) > -1} />
                                    <ListItemText primary={data.label} />
                                  </MenuItem>
                                ))}
                                </Select>
                            
                            </div>      

                            <div style={{position:"relative", float:"left", width:"33%", marginRight:"5px"}}>
                            <FormControl style={{width:"100%"}}>
                              <label style={{paddingLeft:5, paddingRight:5, position:"absolute", backgroundColor:"white", transform: "translate(14px, -10px) scale(0.75)", zIndex:1, top:0, fontWeight:700, color:"rgba(0, 0, 0, 0.6)", fontSize:"1rem", fontFamily:"'Roboto','Helvetica','Arial',sans-serif"}} className="" data-shrink="true" htmlFor="input-trade_name" id="input-trade_name-label">Branża</label>
                              
                              <Select
                                onChange={this.Validators.onTradeNameChange.bind(this.Validators)}
                                value={(this.state.c_data.trade_name == null || this.state.c_data.trade_name == undefined) ? '' : this.state.c_data.trade_name}
                                id="input-trade_name"
                                size="small"
                                error={this.state.input_name_state.error}
                                style={{marginBottom:20, width:"100%", float:"left", marginRight:"5px"}}
                                
                              >
                                 {this.state.data_contractortrades.map((data) => (
                                  <MenuItem key={data.label} value={data.label}>                
                                    <ListItemText primary={data.label} style={{display: "contents", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "pre"}}/>
                                  </MenuItem>
                                ))}
                                </Select>
                                </FormControl>
                            </div>     
                            <div style={{position:"relative", float:"left", width:"32%", marginRight:"5px"}}>
                              <label style={{paddingLeft:5, paddingRight:5, position:"absolute", backgroundColor:"white", transform: "translate(14px, -10px) scale(0.75)", zIndex:1, top:0, fontWeight:700, color:"rgba(0, 0, 0, 0.6)", fontSize:"1rem", fontFamily:"'Roboto','Helvetica','Arial',sans-serif"}} className="" data-shrink="true" htmlFor="input-gtu_array" id="input-gtu_array-label">Grupa towarowa</label>
                          
                              <Select
                                multiple
                                value={this.state.c_data.gtu_array}
                                onChange={this.Validators.handleGTUChange.bind(this.Validators)}
                                id="input-gtu_array"
                                size="small"
                                error={this.state.input_name_state.error}
                                //renderValue={(selected) => selected.join(', ')}
                                renderValue={(selected) => selected
                                  .filter((val) => val != "None")
                                  .map((val) => val)
                                  .join(", ")}
                                style={{marginBottom:20, width:"100%", float:"left", marginRight:"5px"}}
                              >
                                {
                                this.state.data_gtu.map((data) => (
                                  <MenuItem key={data.label} value={data.label}>
                                     <Checkbox checked={this.state.c_data.gtu_array.indexOf(data.label) > -1} />
                                    <ListItemText primary={data.label} />
                                  </MenuItem>
                                ))}
                                </Select>
                            </div>                                
                            <div style={{clear:"both"}}></div>
                        </div>  
                        <div>
                            <div style={{position:"relative", float:"left", width:"33%", marginRight:"5px"}}>
                            <FormControl style={{width:"100%"}}>
                              <label style={{paddingLeft:5, paddingRight:5, position:"absolute", backgroundColor:"white", transform: "translate(14px, -10px) scale(0.75)", zIndex:1, top:0, fontWeight:700, color:"rgba(0, 0, 0, 0.6)", fontSize:"1rem", fontFamily:"'Roboto','Helvetica','Arial',sans-serif"}} className="" data-shrink="true" htmlFor="input-contractor_type" id="input-contactor_state-label">Status</label>
                          
                              <Select
                                id="input-contractor_state"
                                onChange={this.Validators.onStateChange.bind(this.Validators)}
                                value={this.state.c_data.contractor_state == null || this.state.c_data.contractor_state == undefined ? '' : this.state.c_data.contractor_state}
                                size="small"
                                error={this.state.input_name_state.error}
                                style={{marginBottom:20, width:"100%", float:"left", marginRight:"5px"}}
                                >
                                {this.state.data_contractorstates.map((data) => (
                                 <MenuItem key={data.label} value={data.label}>                
                                   <ListItemText primary={data.label} style={{display: "contents", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "pre"}}/>
                                 </MenuItem>
                               ))}
                               </Select>
                            </FormControl>

                            </div>       
                            <div style={{position:"relative", float:"left", width:"33%", marginRight:"5px"}}>
                            <FormControl style={{width:"100%"}}>
                              <label style={{paddingLeft:5, paddingRight:5, position:"absolute", backgroundColor:"white", transform: "translate(14px, -10px) scale(0.75)", zIndex:1, top:0, fontWeight:700, color:"rgba(0, 0, 0, 0.6)", fontSize:"1rem", fontFamily:"'Roboto','Helvetica','Arial',sans-serif"}} className="" data-shrink="true" htmlFor="input-contractor_type" id="input-contactor_type-label">Typ</label>
                          
                              <Select
                                 onChange={this.Validators.onContractorTypeChange.bind(this.Validators)}
                                 value={this.state.c_data.contractor_type == null || this.state.c_data.contractor_type == undefined ? '' : this.state.c_data.contractor_type}
                                 id="input-contractor_type"
                                 size="small"
                                
                                error={this.state.input_name_state.error}
                                style={{marginBottom:20, width:"100%", float:"left", marginRight:"5px"}}
                                >
                                {this.state.data_ctypes.map((data) => (
                                 <MenuItem key={data.label} value={data.label}>                
                                   <ListItemText primary={data.label} style={{display: "contents", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "pre"}}/>
                                 </MenuItem>
                               ))}
                               </Select>
                            </FormControl>
                            </div>       
                            <div style={{position:"relative", float:"left", width:"32%", marginRight:"5px"}}>
                              <FormControl style={{width:"100%"}}>
                              <label style={{paddingLeft:5, paddingRight:5, position:"absolute", backgroundColor:"white", transform: "translate(14px, -10px) scale(0.75)", zIndex:1, top:0, fontWeight:700, color:"rgba(0, 0, 0, 0.6)", fontSize:"1rem", fontFamily:"'Roboto','Helvetica','Arial',sans-serif"}} className="" data-shrink="true" htmlFor="input-contactor_newmstate" id="input-contactor_newmstate-label">Wysyłka Mailingu</label>
                          
                              <Select
                                onChange={this.Validators.onContractorNewMChange.bind(this.Validators)}
                                value={this.state.c_data.contractor_newmstate == null || this.state.c_data.contractor_newmstate == undefined ? '' : this.state.c_data.contractor_newmstate}
                                id="input-contractor_newmstate"     
                                size="small"
                                error={this.state.input_name_state.error}
                                style={{marginBottom:20, width:"100%", float:"left", marginRight:"5px"}}
                                >
                                {this.state.data_newmstate.map((data) => (
                                 <MenuItem key={data.label} value={data.label}>                
                                   <ListItemText primary={data.label} style={{display: "contents", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "pre"}}/>
                                 </MenuItem>
                               ))}
                               </Select>
                            </FormControl>
                            </div>                                
                            <div style={{clear:"both"}}></div>
                          
                        </div>  
                        <div>
                            <div style={{position:"relative", float:"left", width:"33%", marginRight:"5px"}}>
                            <label style={{paddingLeft:5, paddingRight:5, position:"absolute", backgroundColor:"white", transform: "translate(14px, -10px) scale(0.75)", zIndex:1, top:0, fontWeight:700, color:"rgba(0, 0, 0, 0.6)", fontSize:"1rem", fontFamily:"'Roboto','Helvetica','Arial',sans-serif"}} className="" data-shrink="true" htmlFor="input-classification_array" id="input-classification_array-label">Klasyfikacja</label>
                            
                            <Select
                              multiple
                              onChange={this.Validators.handleClassificationChange.bind(this.Validators)}
                              value={this.state.c_data.classifications_array}
                              id={"input-classifications_array"}
                              placeholder='Wybierz klasyfikacje'
                              size="small"
                              error={this.state.input_name_state.error}
                              //renderValue={(selected) => selected.join(', ')}
                              renderValue={(selected) => selected
                                .filter((val) => val != "None")
                                .map((val) => val)
                                .join(", ")}
                              style={{marginBottom:20, width:"100%", float:"left", marginRight:"5px"}}
                            >
                              {
                              this.state.data_classifications.map((data) => (
                                <MenuItem key={data.label} value={data.label}>
                                   <Checkbox checked={this.state.c_data.classifications_array.indexOf(data.label) > -1} />
                                  <ListItemText primary={data.label} />
                                </MenuItem>
                              ))}
                            </Select>
                              
                            
                            </div>       
                            <div style={{position:"relative", float:"left", width:"33%", marginRight:"5px"}}>
                            <FormControl style={{width:"100%"}}>
                              <label style={{paddingLeft:5, paddingRight:5, position:"absolute", backgroundColor:"white", transform: "translate(14px, -10px) scale(0.75)", zIndex:1, top:0, fontWeight:700, color:"rgba(0, 0, 0, 0.6)", fontSize:"1rem", fontFamily:"'Roboto','Helvetica','Arial',sans-serif"}} className="" data-shrink="true" htmlFor="input-iis_name" id="input-iis_name-label">Spis inwestycji</label>
                          
                              <Select
                                onChange={this.Validators.onContractorIISChange.bind(this.Validators)}
                                 value={this.state.c_data.iis_name == null || this.state.c_data.iis_name == undefined ? '' : this.state.c_data.iis_name}
                                id="input-iis_name"
                                size="small"
                                
                                error={this.state.input_name_state.error}
                                style={{marginBottom:5, width:"100%", float:"left", marginRight:"5px"}}
                                >
                                {this.state.data_iis.map((data) => (
                                 <MenuItem key={data.label} value={data.label}>                
                                   <ListItemText primary={data.label} style={{display: "contents", textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "pre"}}/>
                                 </MenuItem>
                               ))}
                               </Select>

                              </FormControl>
                            </div>       
                            <div style={{position:"relative", float:"left", width:"32%", marginRight:"5px"}}>
                              <label style={{paddingLeft:5, paddingRight:5, position:"absolute", backgroundColor:"white", transform: "translate(14px, -10px) scale(0.75)", zIndex:1, top:0, fontWeight:700, color:"rgba(0, 0, 0, 0.6)", fontSize:"1rem", fontFamily:"'Roboto','Helvetica','Arial',sans-serif"}} className="" data-shrink="true" htmlFor="input-group_names_array" id="input-group_names_array-label">Grupa</label>
                          
                              <Select
                                multiple
                                onChange={this.Validators.onContractorGroupsChange.bind(this.Validators)}
                                 value={this.state.c_data.group_names_array}
                                id="input-group_names_array"     
                                size="small"
         
                                error={this.state.input_name_state.error}
                                //renderValue={(selected) => selected.length==1 && selected[0] =='None' ?   '' : selected.join(', ') }
                                renderValue={(selected) => selected
                                  .filter((val) => val != "None")
                                  .map((val) => val)
                                  .join(", ")}
                                style={{marginBottom:5, width:"100%", float:"left", marginRight:"5px"}}
                                >
                                 {
                                this.state.data_contractorgroups.map((data) => (
                                  <MenuItem key={data.label} value={data.label}>
                                     <Checkbox checked={this.state.c_data.group_names_array.indexOf(data.label) > -1} />
                                    <ListItemText primary={data.label} />
                                  </MenuItem>
                                ))}
                          
                               </Select>
                            </div>                                
                            <div style={{clear:"both"}}></div>
                          
                        </div>  
                        <FormControlLabel control={<Checkbox
                        onChange={this.Validators.onIsPersonChange.bind(this.Validators)}
                        checked={this.state.c_data.isperson == null ? false : this.state.c_data.isperson>0} 
                        
                        />} label="Osoba fizyczna" />
                        
                        
                      
                    </div>  
                  </div>
                  {/*/.col (left) */}
                  {/* right column */}
                  <div className="col-md-6" >
                    <div className="card card-info" style={{padding:"5px"}}>
                      <div className="card-header" style={{marginBottom:10}}>
                        <h3 className="card-title">Dane teleadresowe</h3>
                        
                      </div>
                    
                        <div>
                          <TextField
                            label="Telefon"
                            id="input-phone"
                            placeholder='Wprowadź nr telefonu'
                            size="small"
                            value={this.state.c_data.phone == null || this.state.c_data.phone == undefined ? '' : this.state.c_data.phone}
                            InputLabelProps={{ shrink: true }}
                            error={this.state.input_phone_state.error}
                            helperText={this.state.input_phone_state.helperText}
                            onChange={this.Validators.onPhonechange.bind(this.Validators)}
                            style={{marginBottom:20, width:"33%", float:"left", marginRight:"5px"}}
                          />

                          <TextField
                            label="Email z NL"
                            id="input-mail"
                            placeholder='Wprowadź...'
                            size="small"
                            value={this.state.c_data.mail == null || this.state.c_data.mail == undefined ? '' : this.state.c_data.mail}
                            InputLabelProps={{ shrink: true }}
                            error={this.state.input_mail_state.error}
                            helperText={this.state.input_mail_state.helperText}
                            onChange={this.Validators.onMailchange.bind(this.Validators)}
                            style={{marginBottom:20, width:"33%", float:"left", marginRight:"5px"}}
                          />
 
                          <TextField
                            label="FAX"
                            id="input-fax"
                            placeholder='Wprowadź...'
                            size="small"
                            value={this.state.c_data.fax == null || this.state.c_data.fax == undefined ? '' : this.state.c_data.fax}
                            InputLabelProps={{ shrink: true }}
                            error={this.state.input_fax_state.error}
                            helperText={this.state.input_fax_state.helperText}
                            onChange={this.Validators.onFaxchange.bind(this.Validators)}
                            style={{marginBottom:20, width:"32%", float:"left", marginRight:"5px"}}
                          />

                          <div style={{clear:"both"}}></div>
                        </div>

                       
                          
                          <div>
                            <TextField
                              label="Adres siedziby"
                              id="input-street"
                              placeholder='Wprowadź adres siedziby'
                              size="small"
                              value={this.state.c_data.street == null || this.state.c_data.street == undefined ? '' : this.state.c_data.street}
                              required={true}
                              InputLabelProps={{ shrink: true }}
                              error={this.state.input_street_state.error}
                              helperText={this.state.input_street_state.helperText}
                              onChange={this.Validators.onStreetChange.bind(this.Validators)}
                              style={{marginBottom:20, width:"25%", float:"left", marginRight:"5px"}}
                            />
                            <TextField
                              label="Miasto"
                              id="input-city"
                              placeholder='Wprowadź...'
                              size="small"
                              value={this.state.c_data.city == null || this.state.c_data.city == undefined ? '' : this.state.c_data.city}
                              required={true}
                              InputLabelProps={{ shrink: true }}
                              error={this.state.input_city_state.error}
                              helperText={this.state.input_city_state.helperText}
                              onChange={this.Validators.onCityChange.bind(this.Validators)}
                              style={{marginBottom:20, width:"20%",  float:"left",  marginRight:"5px"}}
                              
                            />

                            <TextField
                              label="Kod pocztowy"
                              id="input-postcode"
                              placeholder='Wprowadź...'
                              size="small"
                              value={this.state.c_data.postcode == null || this.state.c_data.postcode == undefined ? '' : this.state.c_data.postcode}
                              required={true}
                              InputLabelProps={{ shrink: true }}
                              error={this.state.input_postcode_state.error}
                              helperText={this.state.input_postcode_state.helperText}
                              onChange={this.Validators.onPostcodechange.bind(this.Validators)}
                              style={{marginBottom:20, width:"15%", float:"left",  marginRight:"5px"}}

                            />

                            <TextField
                              label="Kraj"
                              id="input-country"
                              placeholder='Wprowadź...'
                              size="small"
                              value={this.state.c_data.country == null || this.state.c_data.country == undefined ? '' : this.state.c_data.country}
                              required={true}
                              InputLabelProps={{ shrink: true }}
                              error={this.state.input_country_state.error}
                              helperText={this.state.input_country_state.helperText}
                              onChange={this.Validators.onCountryChange.bind(this.Validators)}
                              style={{marginBottom:20, width:"15%",  float:"left", marginRight:"5px"}}
                              
                            />
                            <TextField
                              label="Województwo"
                              id="input-province"
                              placeholder='Wprowadź...'
                              size="small"
                              value={this.state.c_data.province == null || this.state.c_data.province == undefined ? '' : this.state.c_data.province}
                              required={true}
                              InputLabelProps={{ shrink: true }}
                              error={this.state.input_province_state.error}
                              helperText={this.state.input_province_state.helperText}
                              onChange={this.Validators.onProvinceChange.bind(this.Validators)}
                              style={{marginBottom:20, width:"20%",  float:"left"}}
                              
                            />
                            <div style={{clear:"both"}}></div>
                          </div>

                          <div>
                            <TextField
                              label="Adres koresp. siedziby"
                              id="input-cor_street"
                              placeholder='Wprowadź adres korespondencyjny'
                              size="small"
                              value= {this.state.c_data.cor_street == null || this.state.c_data.cor_street == undefined ? '' : this.state.c_data.cor_street}
                              InputLabelProps={{ shrink: true }}
                              error={this.state.input_cor_street_state.error}
                              helperText={this.state.input_cor_street_state.helperText}
                              onChange={this.Validators.onCorrStreetChange.bind(this.Validators)}
                              style={{marginBottom:20, width:"25%", float:"left", marginRight:"5px"}}
                            />
                            <TextField
                              label="Miasto"
                              id="input-cor_city"
                              placeholder='Wprowadź...'
                              size="small"
                              value={this.state.c_data.cor_city == null || this.state.c_data.cor_city == undefined ? '' : this.state.c_data.cor_city}
                              InputLabelProps={{ shrink: true }}
                              error={this.state.input_cor_city_state.error}
                              helperText={this.state.input_cor_city_state.helperText}
                              onChange={this.Validators.onCorrCityChange.bind(this.Validators)}
                              style={{marginBottom:20, width:"20%",  float:"left",  marginRight:"5px"}}
                              
                            />

                            <TextField
                              label="Kod pocztowy"
                              id="input-cor_postcode"
                              placeholder='Wprowadź...'
                              size="small"
                              value={this.state.c_data.cor_postcode == null || this.state.c_data.cor_postcode == undefined ? '' : this.state.c_data.cor_postcode}
                              InputLabelProps={{ shrink: true }}
                              error={this.state.input_cor_postcode_state.error}
                              helperText={this.state.input_cor_postcode_state.helperText}
                              onChange={this.Validators.onCorrPostcodechange.bind(this.Validators)}
                              style={{marginBottom:20, width:"15%", float:"left",  marginRight:"5px"}}

                            />

                            <TextField
                              label="Kraj"
                              id="input-cor_country"
                              placeholder='Wprowadź...'
                              size="small"
                              value={this.state.c_data.cor_country == null || this.state.c_data.cor_country == undefined ? '' : this.state.c_data.cor_country}
                              InputLabelProps={{ shrink: true }}
                              error={this.state.input_cor_country_state.error}
                              helperText={this.state.input_cor_country_state.helperText}
                              onChange={this.Validators.onCorrCountryChange.bind(this.Validators)}
                              style={{marginBottom:20, width:"15%",  float:"left", marginRight:"5px"}}
                              
                            />
                            <TextField
                              label="Województwo"
                              id="input-cor_province"
                              placeholder='Wprowadź...'
                              size="small"
                              value={this.state.c_data.cor_province == null || this.state.c_data.cor_province == undefined ? '' : this.state.c_data.cor_province}
                              InputLabelProps={{ shrink: true }}
                              error={this.state.input_cor_province_state.error}
                              helperText={this.state.input_cor_province_state.helperText}
                              onChange={this.Validators.onCorrProvinceChange.bind(this.Validators)}
                              style={{marginBottom:20, width:"20%",  float:"left"}}
                              
                            />
                            <div style={{clear:"both"}}></div>
                          </div >

                          <div>
                          <TextField
                            label= {this.state.c_data.webpage == null || this.state.c_data.webpage == undefined ? '' :   this.state.c_data.webpage.includes('http://') || this.state.c_data.webpage.includes('https://') ? <Link target="_blank" href={this.state.c_data.webpage} >Strona WWW</Link> : <Link target="_blank" href={'http://'+this.state.c_data.webpage} >Strona WWW</Link>}
                            id="input-webpage"
                            placeholder='Wprowadź...'
                            size="small"
                            value={this.state.c_data.webpage == null || this.state.c_data.webpage == undefined ? '' : this.state.c_data.webpage }
                            InputLabelProps={{ shrink: true }}
                            error={this.state.input_webpage_state.error}
                            helperText={this.state.input_webpage_state.helperText}
                            onChange={this.Validators.onWebpageChange.bind(this.Validators)}
                            style={{marginBottom:5, width:"33%", float:"left", marginRight:"5px"}}
                          />
                          <TextField
                            label="REGON"
                            id="input-regon"
                            placeholder='Wprowadź...'
                            size="small"
                            value={this.state.c_data.krs == null || this.state.c_data.krs == undefined ? '' : this.state.c_data.krs}
                            InputLabelProps={{ shrink: true }}
                            error={this.state.input_regon_state.error}
                            helperText={this.state.input_regon_state.helperText}
                            onChange={this.Validators.onKRSchange.bind(this.Validators)}
                            style={{marginBottom:5, width:"33%", float:"left", marginRight:"5px"}}
                          />

                          <TextField
                            label="KRS"
                            id="input-krs"
                            placeholder='Wprowadź...'
                            size="small"
                            value={this.state.c_data.regon == null || this.state.c_data.regon == undefined ? '' : this.state.c_data.regon}
                            InputLabelProps={{ shrink: true }}
                            error={this.state.input_krs_state.error}
                            helperText={this.state.input_krs_state.helperText}
                            onChange={this.Validators.onREGONchange.bind(this.Validators)}
                            style={{marginBottom:5, width:"32%", float:"left", marginRight:"5px"}}
                          />

                          <div style={{clear:"both"}}></div>
                        </div>  
                        
                        <FormControlLabel  control={<Checkbox 
                             onChange={this.Validators.onSendmailChange.bind(this.Validators)}
                             checked={this.state.c_data.sendmail == null ? false : this.state.c_data.sendmail>0} 
                             
                               />
                            }

                            label="Przypomnienie (wysyła maila z przypomnieniem 15 min. przed kontaktem)" 
                          />
                        <div>
                          <div style={{marginBottom:5, width:"45%", float:"left", marginRight:"5px"}}>
                          <FormControlLabel  control={<Checkbox  
                               onChange={this.Validators.onUnsubEmlChange.bind(this.Validators)}
                               checked={this.state.c_data.unsub_eml == null ? false : this.state.c_data.unsub_eml>0}  
                              />} label="E-mail rezygnacja z NL" />
                          </div>
                          <div style={{marginBottom:5, width:"45%", float:"left", marginRight:"5px"}}>
                          <FormControlLabel control={<Checkbox 
                              onChange={this.Validators.onUnsubTelChange.bind(this.Validators)}
                              checked={this.state.c_data.unsub_tel == null ? false : this.state.c_data.unsub_tel>0}    
                            />} label="Telefon rezygnacja z NL" />
                          </div>
                          <div style={{clear:"both"}}></div>
                        </div>
                        

                      
                    </div>  
                  </div>
                  {/*/.col (right) */}
                </div>
                {/* /.row */}
              </div>{/* /.container-fluid */}
            </section>

        </>;
    }

}

export default ContractorCardFormData